/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoginUserResponseDto } from './LoginUserResponseDto';
import {
    LoginUserResponseDtoFromJSON,
    LoginUserResponseDtoFromJSONTyped,
    LoginUserResponseDtoToJSON,
    LoginUserResponseDtoToJSONTyped,
} from './LoginUserResponseDto';

/**
 * 
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {
    /**
     * 
     * @type {LoginUserResponseDto}
     * @memberof LoginResponseDto
     */
    user: LoginUserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDto
     */
    token: string;
}

/**
 * Check if a given object implements the LoginResponseDto interface.
 */
export function instanceOfLoginResponseDto(value: object): value is LoginResponseDto {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function LoginResponseDtoFromJSON(json: any): LoginResponseDto {
    return LoginResponseDtoFromJSONTyped(json, false);
}

export function LoginResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'user': LoginUserResponseDtoFromJSON(json['user']),
        'token': json['token'],
    };
}

export function LoginResponseDtoToJSON(json: any): LoginResponseDto {
    return LoginResponseDtoToJSONTyped(json, false);
}

export function LoginResponseDtoToJSONTyped(value?: LoginResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': LoginUserResponseDtoToJSON(value['user']),
        'token': value['token'],
    };
}

